var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.dlgTitle,
            width: "90%",
            top: "5vh",
            visible: "",
          },
          on: { opened: _vm.onDialogOpened, close: _vm.onDialogClosed },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticClass: "search-row" },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "search-radio",
                      model: {
                        value: _vm.radioValue,
                        callback: function ($$v) {
                          _vm.radioValue = $$v
                        },
                        expression: "radioValue",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: "downloadNonHistoryRecords" } },
                        [_vm._v(_vm._s(_vm.$t("FILE_NONE_DOWNLOAD")))]
                      ),
                      _c("el-radio", { attrs: { label: "downloadSelfNone" } }, [
                        _vm._v(_vm._s(_vm.$t("FILE_SELF_NONE_DOWNLOAD"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("el-date-picker", {
                        staticClass: "search-dateRange",
                        attrs: {
                          type: "daterange",
                          "range-separator": "~",
                          "start-placeholder": _vm.$t("file_upload_start_date"),
                          "end-placeholder": _vm.$t("file_upload_end_date"),
                        },
                        model: {
                          value: _vm.uploadDateRange,
                          callback: function ($$v) {
                            _vm.uploadDateRange = $$v
                          },
                          expression: "uploadDateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "search-uploadBy",
                          attrs: {
                            placeholder: _vm.$t("UPLOAD_BY"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.uploadBy,
                            callback: function ($$v) {
                              _vm.uploadBy = $$v
                            },
                            expression: "uploadBy",
                          },
                        },
                        _vm._l(
                          _vm.fileArray
                            .map((v) => v.uploadBy)
                            .reduce((pre, v, k, arr) => {
                              !pre.includes(v) ? pre.push(v) : ""
                              return pre
                            }, []),
                          function (v, k) {
                            return _c("el-option", {
                              key: k,
                              attrs: { label: v, value: v },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("span", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v(_vm._s(_vm.$t("DOWNLOAD_SIZE"))),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            width: "80px",
                            "margin-right": "10px",
                          },
                          attrs: { placeholder: _vm.$t("UNIT") },
                          model: {
                            value: _vm.fileSizeUnit,
                            callback: function ($$v) {
                              _vm.fileSizeUnit = $$v
                            },
                            expression: "fileSizeUnit",
                          },
                        },
                        _vm._l(["kB", "MB", "GB"], function (v, k) {
                          return _c("el-option", {
                            key: k,
                            attrs: { label: v, value: v },
                          })
                        }),
                        1
                      ),
                      _c("el-input-number", {
                        staticStyle: { width: "60px" },
                        attrs: {
                          min: 0,
                          controls: false,
                          placeholder: ">0",
                          type: "number",
                        },
                        model: {
                          value: _vm.fileSize[0],
                          callback: function ($$v) {
                            _vm.$set(_vm.fileSize, 0, $$v)
                          },
                          expression: "fileSize[0]",
                        },
                      }),
                      _vm._v("\n                    ~\n                    "),
                      _c("el-input-number", {
                        staticStyle: { width: "60px" },
                        attrs: {
                          min: 0,
                          controls: false,
                          placeholder: ">0",
                          type: "number",
                        },
                        model: {
                          value: _vm.fileSize[1],
                          callback: function ($$v) {
                            _vm.$set(_vm.fileSize, 1, $$v)
                          },
                          expression: "fileSize[1]",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "5px" } },
                    [
                      _c("span", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v(_vm._s(_vm.$t("fileNameKeyword"))),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "100px" },
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.fileName,
                          callback: function ($$v) {
                            _vm.fileName = $$v
                          },
                          expression: "fileName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "10px",
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "margin-right": "10px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "wl-green",
                          on: { click: _vm.onSelectClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("COMMON_CHOOSE")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "multipleTable2",
              attrs: {
                size: "mini",
                height: "50vh",
                border: "",
                data: _vm.paginationData,
                "row-class-name": _vm.tableRowClassName,
              },
            },
            [
              _c("el-table-column", {
                attrs: { width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c("el-checkbox", {
                          attrs: { value: _vm.checkIsAllSelected },
                          on: {
                            change: function ($event) {
                              return _vm.handleAllSelectionChange()
                            },
                          },
                        }),
                        _vm._v(
                          "\n                    (" +
                            _vm._s(_vm.multipleSelection.length) +
                            ")\n                "
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-checkbox", {
                          attrs: { value: _vm.checkIsSelected(scope.row) },
                          on: {
                            change: function ($event) {
                              return _vm.handleSelectionChange(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "fapiaoToEntity",
                  width: "200",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("admin.fapiaoToEntity"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "fapiaoAmount",
                  width: "190",
                  "header-align": "right",
                  align: "right",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("admin.fapiaoAmount"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("formatNumThousandths")(
                                scope.row.fapiaoAmount
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  "show-overflow-tooltip": "",
                  label: _vm.fileNameColName,
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "size",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_SIZE"),
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("fileSize")(scope.row.size))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadDate",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_TIME"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadBy",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_BY"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uploadDate",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("UPLOAD_TIME"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uploadBy",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("UPLOAD_BY"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              scope.row.uploadBy === "System synchronisation"
                                ? _vm.$t("admin.System synchronisation")
                                : scope.row.uploadBy
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              total: _vm.pager.total,
              "current-page": _vm.pager.pageNum,
              "page-size": _vm.pager.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("span", { staticClass: "file-limit-tip" }, [
                _vm._v(_vm._s(_vm.getSizeFormat)),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  on: { click: _vm.onDialogClosed },
                },
                [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: {
                    disabled:
                      _vm.fileDownloading || _vm.multipleSelection.length === 0,
                  },
                  on: { click: _vm.handleOk },
                },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }